var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8729 2.67004H4.13692C3.32672 2.67004 2.66992 3.60833 2.66992 4.76576V15.2443C2.66992 16.4018 3.32672 17.34 4.13692 17.34H15.8729C16.6831 17.34 17.3399 16.4018 17.3399 15.2443V4.76576C17.3399 3.60833 16.6831 2.67004 15.8729 2.67004Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.608 14.284C5.192 14.284 4.984 14.072 4.984 13.648V6.29195C4.984 5.86795 5.192 5.65595 5.608 5.65595C6.024 5.65595 6.232 5.86795 6.232 6.29195V13.648C6.232 14.072 6.024 14.284 5.608 14.284ZM8.86694 14.2C8.41894 14.2 8.19494 13.976 8.19494 13.528V6.41195C8.19494 5.96395 8.41894 5.73995 8.86694 5.73995H11.1829C12.5749 5.73995 13.6469 6.10395 14.3989 6.83195C15.1589 7.55995 15.5389 8.60395 15.5389 9.96395C15.5389 11.324 15.1589 12.372 14.3989 13.108C13.6469 13.836 12.5749 14.2 11.1829 14.2H8.86694ZM9.44294 13.156H11.1109C13.1989 13.156 14.2429 12.092 14.2429 9.96395C14.2429 7.84395 13.1989 6.78395 11.1109 6.78395H9.44294V13.156Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.b7f95def3ee027a0d63116bce3052254.svg";
export { ForwardRef as ReactComponent };